import type { MetadataItem } from '../tool-config-types';

type CodeAnalyzerInput = {
  endpointId?: string;
  question?: string;
};

const isCodeAnalyzerInput = (input: unknown): input is CodeAnalyzerInput =>
  typeof input === 'object' && input !== null;

export const extractCodeAnalyzerMetadata = ({
  input,
}: {
  input: unknown;
  output?: unknown;
}): MetadataItem[] => {
  if (!isCodeAnalyzerInput(input) || !input.endpointId) return [];
  return [{ value: 'Endpoint Graph' }];
};
